import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=2036c349&scoped=true&"
import script from "./Informacion.vue?vue&type=script&lang=js&"
export * from "./Informacion.vue?vue&type=script&lang=js&"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=2036c349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036c349",
  null
  
)

export default component.exports